import { render, staticRenderFns } from "./CustomMonthChargerComponent.vue?vue&type=template&id=36d1d710&scoped=true&"
import script from "./CustomMonthChargerComponent.vue?vue&type=script&lang=js&"
export * from "./CustomMonthChargerComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomMonthChargerComponent.vue?vue&type=style&index=0&id=36d1d710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1d710",
  null
  
)

export default component.exports